module.exports = __webpack_public_path__ + "static/media/legionella_1.f4635be9.svg";